<ll-titulo>Editar escalas globales</ll-titulo>
<ll-toolnavbar></ll-toolnavbar>

<escala-globales-edit [escalaGlobalId]="escalaGlobalId"></escala-globales-edit>
